module.exports = __webpack_public_path__ + "static/media/study 201104.2cb54932.png";